import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components/common';

import { toggleModal } from 'data/actions/modals';
import { deleteStepVersion } from 'data/actions/sequences';
import { modalsSelector, modalOptionsSelector } from 'data/selectors/modals';
import { Container } from '../deleteStep/styles';
import { ModalTitle, CloseIcon, Footer } from '../baseModal/styles';

const DeleteStepVersionModal = () => {
  const dispatch = useDispatch();
  const { visible } = useSelector(modalsSelector);
  const { stepId, letter } = useSelector(modalOptionsSelector);

  const handleClose = () => dispatch(toggleModal('delete_step_version', false));
  const handleDelete = () => {
    dispatch(deleteStepVersion(stepId, letter));
    dispatch(toggleModal('delete_step_version', false));
  };

  return (
    <Modal
      visible={visible}
      title={
        <ModalTitle danger>
          Delete version
          <CloseIcon onClick={handleClose} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={500}
      footer={false}
      onCancel={handleClose}
    >
      <Container>
        <div>{`Are you sure you want to delete Version “${letter}”?`}</div>
      </Container>
      <Footer>
        <Button data-form="true" type="danger" size="large" onClick={handleDelete}>
          Delete
        </Button>
        <Button size="large" type="default" onClick={handleClose}>
          Cancel
        </Button>
      </Footer>
    </Modal>
  );
};

export default DeleteStepVersionModal;
